import { Line } from "react-chartjs-2";
import { extractDateString } from "../../utils/helpers/analyticsUtils";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
} from "chart.js";
import { handleFormatter } from "../../screens/User/analytics/fall-analysis/formUtils";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip
);

const LineChart = ({ dataset, labels, onPointClick }: any) => {
  const handlePointClick = (event: MouseEvent, chartElements: any[]) => {
    if (chartElements.length > 0) {
      const chartElement = chartElements[0];
      const index = chartElement.index;
      const date = labels[index];
      const label = dataset.label;

      const { month, year } = extractDateString(date);

      onPointClick(month, year, label);
    }
  };

  const options = {
    responsive: true,
    interaction: {
      mode: "index" as const,
      intersect: false,
    },
    stacked: false,
    plugins: {
      tooltip: {
        enabled: true,
        intersect: false,
      },
      legend: {
        display: false,
      },
      datalabels: {
        display: true,
        color: "black",
        formatter: (value: any) => handleFormatter(value),
        font: {
          size: 16,
        },
      },
    },
    onClick: (e: any, chart: any) => handlePointClick(e, chart),
    onHover: (e: any, chart: any) => {
      e.native.target.style.cursor = chart[0] ? "pointer" : "default";
    },
  };

  return (
    <div>
      <h3>{dataset?.label ? dataset.label : "Total"}</h3>
      <Line data={{ labels: labels, datasets: [dataset] }} options={options} />
    </div>
  );
};

export default LineChart;
